$(document).ready(function(){
	$('.btn--seeMore').on('click', function(){
		// -- update button --
		$(this).hide();
		$('.btn--seeLess').css({'display': 'inline-flex'});
		// -- show list --
		$('.blockDatesTable .hiddenDates').addClass('active');
	});

	$('.btn--seeLess').on('click', function(){
		// -- update button --
		$(this).hide();
		$('.btn--seeMore').css({'display': 'inline-flex'});
		// -- show list --
		$('.blockDatesTable .hiddenDates').removeClass('active');
	});

});